import { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { unicodeToString } from "../../../../Js/Common";

const WwText = (props) => {
  let [classnames, setClassnames] = useState('SmallChit');
  let [alignClass, setAlignClass] = useState('');
  //let [classnames, setClassnames] = useState('');
  
  useEffect(() => {
    if (
        props.data.style.decoration_classes !== null &&
        props.data.style.decoration_classes !== undefined
    ) {
        setClassnames(`${props.data.style.decoration_classes.join(" ")} SmallChit`);
    }

  //   if (
  //     props.data.class !== null &&
  //     props.data.class !== undefined
  // ) {
  //     setClassnames(`${classnames} ${props.data.class}`);
  // }

    //setClassnames(classnames + " slideInLeft q-pa-xs");

    if (
        props.data.style.align !== null &&
        props.data.style.align !== undefined
    ) {
        setAlignClass(props.data.style.align);
    } else {
        setAlignClass("");
    }

  },[props.data])

  return (
    <>
      {props.data && props.data.source && (
        <div  id={props.data.myId.self} dangerouslySetInnerHTML={{__html: unicodeToString(props.data.source)}} className={classnames} style={{color:'#DB8829',fontWeight: '500',padding: '10px',fontSize: '120%', color: '#DB8829',letterSpacing: '1px',lineHeight: 1.5,textAlign: alignClass, display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block', width: 'inherit'}}></div>
      )}
    </>
  );
};

export default WwText;
